import { Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useFormatter } from '@omnea-app/fe-i18n/useFormatter'
import { TaskStatusEnum } from '@omnea-app/requests/requestsFrontendClient'
import { TaskStatusChip } from '../TaskStatusChip'
import { getTaskRequestLink } from '../utils/getTaskRequestLink'
import { TaskRow } from '../utils/useTaskTableRows'

export const matchesTaskMobileCardContent = (task: TaskRow, searchTermLower: string): boolean => {
  return task.name.toLowerCase().includes(searchTermLower) || task.label.toLowerCase().includes(searchTermLower)
}

export const TaskMobileCard = ({ task }: { task: TaskRow }) => {
  const { t: tTasks } = useTranslation('tasks')
  const { formatDate } = useFormatter()

  const formatDueDate = (dueDate: Date) => {
    return formatDate(dueDate, { format: 'short' })
  }

  const taskIsCompleteOrRejected = task.status === TaskStatusEnum.COMPLETE || task.status === TaskStatusEnum.REJECTED
  return (
    <Card>
      <CardActionArea LinkComponent={Link} href={getTaskRequestLink(task)}>
        <CardContent>
          <Stack gap={3}>
            <Stack sx={{ justifyContent: 'space-between', flexDirection: 'row' }} alignItems="center">
              <TaskStatusChip status={task.status} />
              {!taskIsCompleteOrRejected && task.dueDate && (
                <Typography
                  variant="body-regular"
                  color={task.status === TaskStatusEnum.OVERDUE ? 'text.danger.default' : 'text.muted'}
                >
                  {tTasks('table.mobile.task-card.due')}: {formatDueDate(task.dueDate)}
                </Typography>
              )}
            </Stack>
            <Stack gap={1}>
              <Typography variant="body-medium">{task.label}</Typography>
              <Typography variant="body-regular" color="text.muted">
                {task.name}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
